import React from "react";
import "../CSS/styles.css";

const Credentials = () => {
  return (
    <div className="container py-5">
      <div className="row px-lg-5 justify-content-center">
        <h1 className="mb-0 bc fw-bold text-center">Our Credentials</h1>
        <p className="mb-0 gc mb-0 mt-2 text-center">TAMBRO maintains the highest standards of quality and professionalism in all our services. </p>
        <div className="col-lg-4 col-12 mt-5">
          <div className="mb-0 p-4 container-or-table3 int2">
            <h2 className="text-center mb-0 fw-bold bc">ISO 27001</h2>
            <p className="gc mb-0 mt-2 text-center">Information Security Management</p>
          </div>
        </div>
         <div className="col-lg-4 col-12 mt-lg-5 mt-3">
          <div className="mb-0 p-4 container-or-table3 int2">
            <h2 className="text-center mb-0 fw-bold bc">ISO 9001</h2>
            <p className="gc mb-0 mt-2 text-center">Quality Management Systems</p>
          </div>
        </div>
         <div className="col-lg-4 col-12 mt-lg-5 mt-3">
          <div className="mb-0 p-4 container-or-table3 int2">
            <h2 className="text-center mb-0 fw-bold bc">ISO 22301</h2>
            <p className="gc mb-0 mt-2 text-center">Business Continuity Management</p>
          </div>
        </div>
      </div>
       <div className="row px-lg-5 mt-5 justify-content-center">
        <h3 className="mb-0 bc fw-bold text-center">Strategic Partnerships</h3>
        <p className="mb-0 gc mb-0 mt-2 text-center">We collaborate with leading organizations and institutions worldwide to enhance our service <br /> offerings and deliver comprehensive solutions.</p>
        <div className="col-lg-4 col-12 mt-5">
          <div className="mb-0 p-4 container-or-table3 int2 b2">
            <h2 className="text-center mb-0 fw-bold">Partner 1</h2>
          </div>
        </div>
         <div className="col-lg-4 col-12 mt-lg-5 mt-3">
          <div className="mb-0 p-4 container-or-table3 int2 b2">
            <h2 className="text-center mb-0 fw-bold">Partner 2</h2>
          </div>
        </div>
         <div className="col-lg-4 col-12 mt-lg-5 mt-3">
          <div className="mb-0 p-4 container-or-table3 int2 b2">
            <h2 className="text-center mb-0 fw-bold">Partner 3</h2>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Credentials